import { SelectOptionProps } from '@acceso/design-system';

import { TSupport } from '@/features/programs/api/get-supports';
import { sortSelectOptions } from '@/utils/sortSelectOptions';

const supportLabelCache = new Map<string, string>();

export const getSupportValue = (support: TSupport | undefined) => {
  if (!support) return '';
  if (support.id !== undefined && support.id !== null) {
    return String(support.id);
  }

  return '';
};

export const getSupportAlias = (support: TSupport | undefined) =>
  support?.alias?.[0] || support?.name;

export const setSupportLabelCache = (supportId: string | undefined, label: string | undefined) => {
  if (!supportId || !label) return;
  supportLabelCache.set(supportId, label);
};

export const getCachedSupportLabel = (supportId: string | undefined) => {
  if (!supportId) return undefined;
  return supportLabelCache.get(supportId);
};

const getSupportById = (supportId: string | undefined, allSupports: TSupport[]) => {
  if (!supportId) return undefined;

  return allSupports.find(support => getSupportValue(support) === supportId);
};

export const getSupportAliasById = (supportId: string | undefined, allSupports: TSupport[]) => {
  const support = getSupportById(supportId, allSupports);
  const label = getSupportAlias(support) || getCachedSupportLabel(supportId);

  if (supportId && label) {
    setSupportLabelCache(supportId, label);
  }

  return label;
};

export const buildSupportOption = (support: TSupport): SelectOptionProps | null => {
  const value = getSupportValue(support);
  const label = getSupportAlias(support) || getCachedSupportLabel(value) || '';

  if (!value || !label) return null;

  setSupportLabelCache(value, label);

  return {
    label,
    value,
  };
};

export const buildSupportOptions = (supports: TSupport[]) => {
  return sortSelectOptions(
    supports
      .map(buildSupportOption)
      .filter((option): option is SelectOptionProps => Boolean(option))
  );
};
